import { api } from 'shared/api'

import { GenerateSchema } from './schemas'

export const AiAgentApi = {
  generate: api.account.createPost({
    url: '/aIAgent/generate',
    schemas: GenerateSchema,
    scope: 'ai',
    section: 'ai_agent_generator',
  }),
}
